<div class="coupon" #coupon>
  <div
    class="coupon__label"
    (mouseleave)="mouseEvent(false)"
    (mouseenter)="mouseEvent(true)"
    (touchend)="touchEvent()"
  >
    <p class="coupon__amount">
      {{ windowCouponAmount }} € {{ windowCouponLabel }}
    </p>
    <p class="coupon__text">exklusiv bei CHECK24 sichern</p>
  </div>
    <app-coupon-tip
      *ngIf="popup?.['coupon'] && popup['coupon'] === cardId && windowSize === 'desktop'"
      [sliderWrapper]="sliderWrapper"
      [parent]="coupon"
      (popupEvent)="popupEvent($event)"
    ></app-coupon-tip>
    <ng-template #dialogContent>
      <app-coupon-tip
        *ngIf="windowSize === 'mobile'"
        [sliderWrapper]="sliderWrapper"
        [shouldWrap]="false"
        [parent]="coupon"
        (popupEvent)="popupEvent($event)"
      ></app-coupon-tip>
    </ng-template>
</div>
<ng-template #dialogActions let-close="close">
  <button class="dialogCloseButton" (click)="close()">
    <svg-icon src="/resultpage/assets/icons/X.svg" [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"/>
  </button>
</ng-template>

